import { render, staticRenderFns } from "./ClientesEditar.vue?vue&type=template&id=10d9f1c1&scoped=true&"
import script from "./ClientesEditar.vue?vue&type=script&lang=js&"
export * from "./ClientesEditar.vue?vue&type=script&lang=js&"
import style0 from "./ClientesEditar.vue?vue&type=style&index=0&id=10d9f1c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d9f1c1",
  null
  
)

export default component.exports